<template>
	<section class="main-content contentblocks">
		<div class="row row-header">
			<slot name="content">
				<div class="columns column12">
					<h2
						v-if="contentBlocksSubtitle"
						:class="[
							'subtitle',
							!contentBlocksSubtitle.length && 'no-after',
							!contentBlocksContent.length ? 'column12 align-center' : 'column6',
						]"
					>
						{{ contentBlocksSubtitle }}
					</h2>
				</div>
				<div
					class="columns column6 text"
					:class="!contentBlocksContent.length ? 'column12 align-center' : 'column6'"
				>
					<h1>{{ contentBlocksTitle }}</h1>
				</div>
				<div class="columns column6 content">
					<div v-if="contentBlocksContent.length" v-parse-links v-html="contentBlocksContent" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
		<div v-for="(block, index) in contentblocks" :key="block.ID" class="row contentblock">
			<div class="row contentblock">
				<div class="columns column4 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
					<h2>{{ block.header }}</h2>
					<div v-parse-links v-html="block.content" />
				</div>
				<div class="contentblock-image">
					<picture>
						<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
						<source :srcset="block.image" />
						<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
					</picture>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
	contentBlocksContent: { type: String, default: '' },
	contentBlocksSubtitle: { type: String, default: '' },
	contentBlocksTitle: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--contentblock-background-color);
	background-image: url('~/assets/images/contentblocks-bg.svg');
	background-size: 1680px auto;
	background-repeat: no-repeat;
	background-position: top center;

	.text h1 {
		color: #fff !important;
	}

	.columns {
		padding: 0;

		:deep(p) {
			padding-top: 10px;
		}

		&:nth-child(3) {
			color: #fff;
		}
	}

	.headerblock {
		width: 100%;
		display: flex;
		gap: 15px;
		justify-content: space-between;
	}
}

.background-light {
	background: var(--alternating-background-color);
}

.contentblock {
	margin: 40px auto;
	position: relative;
	padding: 0 16px;

	.columns {
		padding: 50px;
	}

	.row {
		width: 100%;
		padding: 0;
		overflow: hidden;
	}
}

.row-header {
	max-width: 1680px;
	padding: 0 16px;
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 75%;
	z-index: 1;
	padding-bottom: 40px;
}

.contentblock-content {
	background: #fff;
	padding: 60px 90px;
	margin: 60px auto 0;
	position: relative;
	z-index: 2;

	:deep(p) {
		margin: 0;
	}

	:deep(h2) {
		font-size: 38px;
		line-height: 1.3;
	}
}

.row:nth-child(even) .contentblock-image {
	left: 0;
	right: auto;
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 920px) {
	.row {
		overflow: hidden;
	}

	.contentblocks {
		.headerblock {
			flex-flow: column;
		}
	}

	.contentblock {
		width: 90%;
		display: flex;
		flex-flow: wrap column-reverse;
		margin: 20px;
		padding: 0;

		&:nth-child(odd) {
			.contentblock-image {
				margin: auto 0 -50px auto;
			}

			.contentblock-content {
				margin: auto auto -50px 0;
			}
		}

		&:nth-child(even) {
			.contentblock-image {
				margin: auto auto -50px 0;
			}

			.contentblock-content {
				margin: auto 0 -50px auto;
			}
		}
	}

	.contentblock-image {
		width: 90%;
		position: relative;
		inset: auto;
		padding-bottom: 0;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
		width: 90%;

		:deep(p) {
			margin: 0 0 40px;
		}
	}
}

@media (max-width: 600px) {
	.contentblock {
		margin: 10px auto;

		.contentblock-content {
			position: relative;
			width: 90%;
			padding: 20px 30px 60px;
		}
	}

	.contentblock-image {
		height: 400px;
		position: relative;
		width: 90%;
	}
}
</style>
